<div class="drv-coming-soon-card">
  <rmx-icon class="drv-card-icon"
    name="git-commit-line"></rmx-icon>
  <h4 class="drv-card-name">{{ 'CONNECTORS.COMING_SOON.NAME' | translate }}</h4>
  <p class="drv-card-category"
    [innerHTML]="'CONNECTORS.COMING_SOON.CATEGORY' | translate"></p>
</div>
